<template>
    <div id="dashboard-page" style="margin-bottom:55px;">
        <b-card>
            <b-row>
              <b-col md="12">
              <h3>{{$route.name}}</h3>
              <b-breadcrumb>
                <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                <b-breadcrumb-item><router-link to="/company-structure/branch">Branch</router-link></b-breadcrumb-item>
                <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
              </b-breadcrumb>
              <div class="border-bottom"></div>
             </b-col>
            </b-row>
            <b-form class="mt-3 mx-2">
                <b-row>
                    <b-col md="8">
                        <!--<b-row>
                          <b-col md="4"><label class="labels">ID Branch</label></b-col>
                          <b-col md="8"><p>{{ model.code !== null ? model.code : '-' }}</p></b-col>
                        </b-row>-->
                        <b-row>
                          <b-col md="3"><label class="labels">Name</label></b-col>
                          <b-col md="8"><p>{{ model.name !== '' ? model.name : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="3"><label class="labels">Company</label></b-col>
                          <b-col md="8"><p>{{ model.company !== '' ? model.company.name : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="3"><label class="labels">Use Geofence</label></b-col>
                          <b-col md="8"><p>{{ model.geofence !== null ? getNameGeofance(model.geofence) : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="3"><label class="labels">Email</label></b-col>
                          <b-col md="8"><p>{{ model.email !== '' ? model.email : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="3"><label class="labels">Address</label></b-col>
                          <b-col md="8"><p class="text-justify">{{ model.address !== '' ? model.address : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="3"><label class="labels">Telephone</label></b-col>
                          <b-col md="8"><p>{{ model.phone }} {{ model.extPhone === '' ? '' : '- ' + model.extPhone }}</p></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="3"><label class="labels">Fax</label></b-col>
                          <b-col md="8"><p>{{ model.fax !== null ? model.fax : '-' }}</p></b-col>
                        </b-row>

                        <b-row>
                          <b-col md="3"><label class="labels">location</label></b-col>
                          <b-col md="8">
                              <GmapMap v-if="this.model.longitude > 0"
                                :center="location"
                                :zoom="17"
                                map-type-id="terrain"
                                style="width: 100%; height: 400px"
                              >
                                <GmapMarker
                                  :position="location"
                                  :clickable="true"
                                  :draggable="true"
                                  @click="center = location"
                                />
                              </GmapMap>
                              <h6 v-else>no location found</h6>
                            <div>
                            </div>
                          </b-col>
                        </b-row>
                        <!--<b-row>
                            <b-col md="4"><label class="labels">Status Office</label></b-col>
                            <b-col md="8"><p><b-badge :variant="getStatusColor(model.isHq)">{{getStatusName(model.isHq)}}</b-badge></p></b-col>
                        </b-row>-->
                    </b-col>
                </b-row>
            </b-form>
            <b-button class="mt-3" :to="'/company-structure/branch'"  variant="secondary"><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button>
            <b-button class="mt-3 float-right" :to="'/company-structure/branch/' + $route.params.uuid + '/edit'" variant="warning"><font-awesome-icon icon="pencil-alt"></font-awesome-icon> Edit</b-button>
        </b-card>
    </div>
</template>

<script>

    export default {
        name: 'branch-details',
        data () {
            return {
                isLoading: false,
                apiUrl: {
                    branch: window.AppConfig.apiUrl + 'branch'
                },
                model: {
                    company: {
                        name: null
                    },
                    code: '',
                    name: '',
                    address: '',
                    phone: '',
                    extPhone: '',
                    fax: '',
                    email: '',
                    isHq: '',
                    geofence: false,
                    latitude: 0,
                    longitude: 0
                },
                location: {lat: 0, lng: 0}
            }
        },
        mounted () {
            this.getDetail()
        },
        methods: {
            getDetail () {
                this.isLoading = true
                this.$http.get(this.apiUrl.branch + '/' + this.$route.params.uuid).then(response => {
                //   this.model.statusOffice = response.data.statusOffice !== null ? response.data.statusOffice : '-'
                  this.model.company = response.data.company !== '' ? response.data.company : '-'
                  this.model.code = response.data.code !== null ? response.data.code : '-'
                  this.model.name = response.data.name !== '' ? response.data.name : '-'
                  this.model.address = response.data.address !== '' ? response.data.address : '-'
                  this.model.phone = response.data.phone
                  this.model.extPhone = response.data.extPhone
                  this.model.fax = response.data.fax !== null ? response.data.fax : '-'
                  this.model.email = response.data.email !== '' ? response.data.email : '-'
                  this.model.isHq = response.data.isHq === '1' ? true : false
                  this.model.geofence = response.data.geofence
                  this.model.latitude = response.data.latitude
                  this.model.longitude = response.data.longitude

                  const place = response.data
                  this.location = {
                    lat: place.latitude,
                    lng: place.longitude
                  }
                  console.log('maps', this.location);
                })
                .catch(error => {
                    this.isLoading = false
                    this.$store.dispatch('notification/error', error)
                })
            },
            getDateTime (value) {
                if (value !== null) {
                    return this.$moment(value).format('YYYY-MM-DD HH:mm A')
                } else {
                    return '-'
                }
            },
            goBack () {
                window.goBack(this)
            },

            getNameGeofance(val){
              switch (val) {
                case true:
                  return 'YES'

                case false:              
                return 'NO';
              }
            },
            getStatusColor (val) {
              if (val) {
                return "success"
              } else {
                return "secondary"
              }
            },
            getStatusName (val) {
              if (val) {
                return "Headquarters"
              } else {
                return "Branch"
              }
            }
        }
    }
</script>